import { createFileRoute } from "@tanstack/react-router";
import ProductHub from "@/pages/ProductHub";
import { hubArticlesQueryOptions } from "@/lib/hubArticles";

export const Route = createFileRoute("/pressure-washers/")({
  loader: async ({ context }) => {
    await context.queryClient.ensureQueryData(hubArticlesQueryOptions("pressure-washers")).catch(() => null);
  },
  component: () => <ProductHub hubSlug="pressure-washers" />,
});
